import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';

import intlEquipped from '../../../../../hocs/intlEquipped';
import ITunesDetailsContent from './ITunesDetailsContent';

export default compose(
    themr('SapiSubscriptionModuleITunesDetailsContent'),
    intlEquipped
)(ITunesDetailsContent);
